import React, { useState, useEffect } from 'react';
import api from '../../api';
import StyleList from './StyleList';
import StyleForm from './StyleForm';
import StyleImportExport from './StyleImportExport';

import '../../styles/styles.css';
import '../../styles/button.css';
import '../../styles/form.css';

const StylesManager = () => {
  const [styles, setStyles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedStyle, setSelectedStyle] = useState(null);
  const [view, setView] = useState('list'); // 'list', 'add', 'edit'

  // Récupérer tous les styles au chargement du composant
  useEffect(() => {
    fetchStyles();
  }, []);

  const fetchStyles = async () => {
    try {
      setLoading(true);
      const response = await api.get('/api/admin/styles');
      setStyles(response.data);
      setError(null);
    } catch (err) {
      console.error('Erreur lors du chargement des styles:', err);
      setError('Impossible de charger les styles. Veuillez réessayer plus tard.');
    } finally {
      setLoading(false);
    }
  };

  const handleAddStyle = async (styleData) => {
    try {
      const response = await api.post('/api/admin/styles', styleData);
      setStyles([...styles, response.data]);
      setView('list');
      return { success: true };
    } catch (err) {
      console.error('Erreur lors de l\'ajout du style:', err);
      return { 
        success: false, 
        error: err.response?.data?.error || 'Erreur lors de l\'ajout du style' 
      };
    }
  };

  const handleUpdateStyle = async (styleData) => {
    try {
      const response = await api.put(`/api/admin/styles/${styleData.id}`, styleData);
      setStyles(styles.map(s => s.id === styleData.id ? response.data : s));
      setView('list');
      setSelectedStyle(null);
      return { success: true };
    } catch (err) {
      console.error('Erreur lors de la mise à jour du style:', err);
      return { 
        success: false, 
        error: err.response?.data?.error || 'Erreur lors de la mise à jour du style' 
      };
    }
  };

  const handleDeleteStyle = async (styleId) => {
    try {
      await api.delete(`/api/admin/styles/${styleId}`);
      setStyles(styles.filter(s => s.id !== styleId));
      return { success: true };
    } catch (err) {
      console.error('Erreur lors de la suppression du style:', err);
      return { 
        success: false, 
        error: err.response?.data?.error || 'Erreur lors de la suppression du style' 
      };
    }
  };

  const handleEditClick = (style) => {
    setSelectedStyle(style);
    setView('edit');
  };

  const handleAddClick = () => {
    setSelectedStyle(null);
    setView('add');
  };

  const handleCancelForm = () => {
    setView('list');
    setSelectedStyle(null);
  };

  if (loading) {
    return <div className="panel panel-primary text-center">Chargement des styles...</div>;
  }

  return (
    <div className="container">
      <div className="panel panel-primary">
        <h1 className="panel-title">Gestion des Styles</h1>
        
        {view === 'list' && (
          <div>
            <div className="mb-4">
              <button className="btn btn-primary" onClick={handleAddClick}>
                Ajouter un nouveau style
              </button>
              <StyleImportExport onImportComplete={fetchStyles} styles={styles} />
            </div>
            
            {error && <div className="panel panel-primary" style={{ borderColor: 'var(--color-error)' }}>{error}</div>}
            
            <StyleList 
              styles={styles} 
              onEditClick={handleEditClick}
              onDeleteStyle={handleDeleteStyle}
            />
          </div>
        )}

        {(view === 'add' || view === 'edit') && (
          <StyleForm 
            style={selectedStyle} 
            onSubmit={view === 'add' ? handleAddStyle : handleUpdateStyle}
            onCancel={handleCancelForm}
          />
        )}
      </div>
    </div>
  );
};

export default StylesManager; 